export default __webpack_public_path__ + "static/media/EnergyIndustries_bg.fb71bfa1.jpg";